module.exports = __webpack_public_path__ + "img/SYL_cover.cd69e56a.png";